import { User } from 'models/User';
import { createContext } from 'react';
import utils from 'utils';

type AuthContextValues = {
  user: User;
  updateUser: (data: User) => void;
  isAuthorised: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
};

export default createContext<AuthContextValues>({
  user: null,
  updateUser: utils.noop,
  isAuthorised: false,
  isAdmin: false,
  isSuperAdmin: false,
});
